export enum PaymentTypeEnum {
  DOTPAY = 'Przelewy24',
  BANK = 'transfer',
}
